import { render, staticRenderFns } from "./BoilerOptions.vue?vue&type=template&id=5b6eb06d&lang=pug&"
import script from "./BoilerOptions.vue?vue&type=script&lang=js&"
export * from "./BoilerOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports